import "./theme.css";

export const theme = {
  modal: "chrome-modal",
  overlay: "chrome-overlay",
  header: "chrome-header",
  container: "chrome-container",
  content: "chrome-content",
  containerOpen: "chrome-containerOpen",
  input: "chrome-input",
  inputOpen: "chrome-inputOpen",
  inputFocused: "chrome-inputFocused",
  spinner: "chrome-spinner",
  suggestionsContainer: "chrome-suggestionsContainer",
  suggestionsContainerOpen: "chrome-suggestionsContainerOpen",
  suggestionsList: "chrome-suggestionsList",
  suggestion: "chrome-suggestion",
  suggestionFirst: "chrome-suggestionFirst",
  suggestionHighlighted: "chrome-suggestionHighlighted",
  trigger: "chrome-trigger",
};
